class StockUpdate {
  constructor() {
    this.init();
  }

  init() {
    const productStock = document.querySelectorAll("[data-product-stock]");
    if (productStock.length == 0) {
      return;
    }
    let productIds = [];

    productStock.forEach((el) => {
      productIds.push(el.dataset.productStock);
    });

    let productQueryString = productIds.join(",");

    fetch("/shop/api/stock/?products=" + productQueryString, {
      credentials: "same-origin",
    })
      .then((res) => res.json())
      .then((data) => {
        productStock.forEach((el) => {
          const productId = el.dataset.productStock;
          const stock = data[productId];
          el.textContent = stock;

          document
            .querySelectorAll(
              `input[name=item_id][data-product-id="${productId}"]`
            )
            .forEach((radio) => {
              radio.dataset.remaining = stock;
            });
        });

        document
          .querySelectorAll("input[name=item_id]:checked")
          .forEach((radio) => {
            radio.dispatchEvent(new Event("change", { bubbles: true }));
          });
      });
  }
}

export default StockUpdate;
